/* istanbul ignore file */
import React from 'react';
import VacancyPublicationLink from 'domain/recruiting/vacancy/publication/shared/field/VacancyPublicationLink';

const VacancyPublicationListLinkField = ({ value = {} }: { value?: any }) => {
  return <VacancyPublicationLink id={value.id} name={value.type} />;
};

export default VacancyPublicationListLinkField;
